import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import {
  AvoidSpace,
  CatchMessage,
  JSONtoformdata,
  PreventPasting,
} from "../../Shared/Methods";
import { useFormik } from "formik";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { Changepassword } from "../../Services/ApiServices";
import { toast } from "react-toastify";
import Loader from "../../SharedComponents/Loader/Loader";
import classes from "./Login.module.css";
import CommonInput from "../../Components/CommonForms/CommonInput";
import CommonButton from "../../Components/Buttons/CommonButton";
import { PasswordExp, ProjectID, lengths } from "../../Shared/Constants";
import passwordIcon from "../../Assests/Icons/password.svg";

const validation = Yup.object().shape({
  password: Yup.string()
    .min(5, "Password should contain at least 5 characters")
    .matches(
      PasswordExp,
      "Password must contain at least one lower and upper case character and a digit"
    )
    .required("Password is required"),

  confirm_password: Yup.string()
    .oneOf(
      [Yup.ref("password"), undefined],
      `Confirm Password must be equal to "Password"`
    )
    .required("Confirm Password is required"),
});

interface formikprops {
  organization_code: string;
  email_ph_no: string;
  iscodetype: boolean;
  type: number;
}

function ChangePassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state: any) => state.Dashboard);
  const location = useLocation();
  const { state } = location || {};
  const { response } = state || {};
  const { reset_key, email, mobileNumber, org_code, frompassword } =
    response || {};

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    handleBlur,
    setValues,
    isSubmitting,
  } = useFormik({
    initialValues: {
      org_code: "",
      password: "",
      confirm_password: "",
      reset_key: "",
    },

    validationSchema: validation,
    onSubmit: (value) => {
      handleChangepassword();
    },
  });

  const handleChangepassword = () => {
    dispatch(handleloading(true));

    const finalObj = {
      ...values,
      ...ProjectID,
      reset_key: reset_key,
      org_code: org_code,
    };

    Changepassword(JSONtoformdata(finalObj))
      .then((res) => {
        if (res?.data?.status === 1) {
          toast.success(res?.data?.msg);
          navigate("/");
        } else if (res?.data?.status === 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      })
      .finally(() => dispatch(handleloading(false)));
  };

  // useEffect(() => {
  //   const disableBackNavigation = (event: PopStateEvent) => {
  //     event.preventDefault();
  //     // setconfirmation(true);
  //     navigate("/forgotpassword");
  //   };

  //   // window.history.pushState(null, "/");
  //   window.addEventListener("popstate", disableBackNavigation);

  //   return () => {
  //     window.removeEventListener("popstate", disableBackNavigation);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <>
      <Loader isLoader={loading} />
      <p className={classes.login_text}>Change Password</p>

      <form
        onSubmit={handleSubmit}
        className={`primaryInput ${classes.login_form_container}`}
        id="remove_image"
      >
        <CommonInput
          name="password"
          value={values?.password}
          onChange={({ target }) => {
            // if (!target.value.includes(" ")) {
            setFieldValue("password", target.value);
            // }
          }}
          required={true}
          error={errors}
          touched={touched}
          labelname={"Password"}
          onPaste={PreventPasting}
          maxLength={lengths.Password}
          onKeyDown={AvoidSpace}
          isInvalid={errors.password && touched.password ? true : false}
          onBlur={handleBlur}
          preIcon={passwordIcon}
          type="password"
          preIconStyles={{
            height: "22px",
          }}
        />

        <CommonInput
          name="confirm_password"
          value={values?.confirm_password}
          onChange={({ target }) => {
            // if (!target.value.includes(" ")) {
            setFieldValue("confirm_password", target.value);
            // }
          }}
          required={true}
          error={errors}
          touched={touched}
          labelname={"Confirm Password"}
          onPaste={PreventPasting}
          maxLength={lengths.Password}
          onKeyDown={AvoidSpace}
          isInvalid={
            errors.confirm_password && touched.confirm_password ? true : false
          }
          onBlur={handleBlur}
          preIcon={passwordIcon}
          type="password"
          preIconStyles={{
            height: "22px",
          }}
        />

        <div className={classes.btn_container}>
          <CommonButton
            name="Submit"
            style={{
              border: "none",
              width: "100px",
              height: "38px",
              color: "white",
              borderRadius: "7px",
            }}
            onClick={() => handleSubmit}
            type="submit"
            classname="submit_btn"
          />
        </div>
      </form>
    </>
  );
}

export default ChangePassword;
